import { render, staticRenderFns } from "./StickyClue.vue?vue&type=template&id=2cb74edc&scoped=true&"
import script from "./StickyClue.vue?vue&type=script&lang=js&"
export * from "./StickyClue.vue?vue&type=script&lang=js&"
import style0 from "./StickyClue.vue?vue&type=style&index=0&id=2cb74edc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb74edc",
  null
  
)

export default component.exports